export default __webpack_public_path__ + "static/media/final2.db0c3776.png";